MessagesRankingStatusComponent = require './MessagesRankingStatusComponent'
InfoBlockComponent = require 'components/shared/InfoBlockComponent'

propTypes = require 'prop-types'

class RankingModule extends React.Component
  componentDidMount: -> @props.setTabsState 'message-info': !!@props.anyOpen

  render: ->
    React.createElement("div", null,
      React.createElement(InfoBlockComponent, {  \
        "dataKey": 'message-info',  \
        "title": 'message-info',  \
        "openByDefault": (!!@props.anyOpen),  \
        "onToggleBlock": (@props.onToggleBlock)
      },
        React.createElement(MessagesRankingStatusComponent, { \
          "userRole": (@props.conversation?.approve_data?.user_role)
        })
      )
    )

RankingModule.propTypes = 
  setTabsState: propTypes.func.isRequired
  onToggleBlock: propTypes.func.isRequired
  anyOpen: propTypes.bool

module.exports = RankingModule
